import { motion } from "framer-motion";
import { MechanismNode, MechanismConnector } from "../MechanismNode";
import { SpecimenLabel } from "../SpecimenLabel";

const STEPS = [
  { step: 1, title: "PASTE", description: "Drop any client feedback" },
  { step: 2, title: "EXTRACT", description: "AI identifies wins, sentiment, structure" },
  { step: 3, title: "DEPLOY", description: "6 formats, ready for every platform" }
];

export const FrameMechanism = () => {
  return (
    <section className="py-32 px-4 sm:px-6 lg:px-8 bg-muted/10">
      <div className="max-w-5xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-20"
        >
          <SpecimenLabel text="THE MECHANISM" className="mb-4 block" />
          <h2 className="font-editorial text-3xl md:text-4xl text-foreground">
            The Thread
          </h2>
        </motion.div>

        {/* Three nodes with connectors */}
        <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-0">
          {STEPS.map((step, i) => (
            <div key={step.step} className="flex items-center">
              <MechanismNode
                step={step.step}
                title={step.title}
                description={step.description}
                delay={i * 0.2}
              />
              {i < STEPS.length - 1 && (
                <MechanismConnector delay={0.3 + i * 0.2} />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
